import { Alert, Card, Select, Tooltip, Spin, TimePicker } from 'antd';
import { FaPhoneAlt, FaExclamationTriangle, FaQuestionCircle } from 'react-icons/fa';
import { getEstadoIcon, getSubestadoIcon } from '../components/IconUtils';


const CallResultStep = ({
  callNumber,
  estadoLlamadaId,
  subestadoLlamadaId,
  setEstadoLlamadaId,
  setSubestadoLlamadaId,
  estadosValidacion,
  subestadosDisponibles,
  loadingSubestados,
  errorCargaSubestados,
  horaLlamada,
  setHoraLlamada
}) => {

  const estadoSeleccionado =
    estadosValidacion?.find(e => e.id === estadoLlamadaId) || null;

  return (
    <>
      {callNumber === 3 && (
        <Alert
          message="Última Llamada"
          description="Esta es la tercera y última llamada. Solo se permiten estados finales."
          type="warning"
          showIcon
          icon={<FaExclamationTriangle />}
          style={{ marginBottom: 16 }}
        />
      )}

      <Card
        size="small"
        style={{ marginBottom: 20 }}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FaPhoneAlt style={{ color: '#1890ff' }} />
            <span>Resultado del Contacto</span>
          </div>
        }
      >
        {/* 🔹 HORA DE LA LLAMADA */}
        <div style={{ marginBottom: 16 }}>
          <strong style={{ display: 'block', marginBottom: 8 }}>
            Hora de la llamada *
          </strong>

          <TimePicker
            style={{ width: '100%' }}
            use12Hours
            format="h:mm a"
            value={horaLlamada}
            onChange={(value) => setHoraLlamada(value)}
            placeholder="Seleccione la hora"
            allowClear={false}
          />
        </div>

        {/* 🔹 ESTADO DE LA LLAMADA */}
        <div style={{ marginBottom: 16 }}>
          <strong style={{ display: 'block', marginBottom: 8 }}>
            Estado de la llamada *
          </strong>

          <Select
            placeholder="Seleccione el resultado del contacto"
            style={{ width: '100%' }}
            value={estadoLlamadaId}
            onChange={(value) => {
              setEstadoLlamadaId(value);
              setSubestadoLlamadaId(null);
            }}
            optionLabelProp="label"
          >
            {estadosValidacion
              .filter(estado => estado.id !== 4)
              .filter(estado => {
                if (callNumber === 3) {
                  return estado.es_estado_final && estado.id !== 4;
                }
                return true;
              })
              .map(estado => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nombre}
                >
                  <Tooltip title={estado.descripcion}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {getEstadoIcon(estado.id)}
                      <span>{estado.nombre}</span>
                      {estado.descripcion && (
                        <FaQuestionCircle
                          style={{ color: '#999', marginLeft: 'auto' }}
                        />
                      )}
                    </div>
                  </Tooltip>
                </Select.Option>
              ))}
          </Select>
        </div>

        {/* 🔹 SUBESTADOS */}
        {estadoSeleccionado?.permite_subestados === 1 && (
          <div>
            <strong style={{ display: 'block', marginBottom: 8 }}>
              Detalle del resultado *
            </strong>

            {loadingSubestados ? (
              <div style={{ textAlign: 'center', padding: 20 }}>
                <Spin size="small" /> Cargando subestados...
              </div>
            ) : errorCargaSubestados ? (
              <Alert
                message="Error cargando subestados"
                description={errorCargaSubestados}
                type="error"
                showIcon
                style={{ marginBottom: 10 }}
              />
            ) : (
              <Select
                placeholder="Seleccione por qué quedó en proceso"
                style={{ width: '100%' }}
                value={subestadoLlamadaId}
                onChange={(value) => setSubestadoLlamadaId(value)}
                optionLabelProp="label"
              >
                {subestadosDisponibles.map(sub => (
                  <Select.Option
                    key={sub.id}
                    value={sub.id}
                    label={sub.nombre}
                  >
                    <Tooltip title={sub.descripcion}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {getSubestadoIcon(sub.id)}
                        <span>{sub.nombre}</span>
                        {sub.descripcion && (
                          <FaQuestionCircle
                            style={{ color: '#999', marginLeft: 'auto' }}
                          />
                        )}
                      </div>
                    </Tooltip>
                  </Select.Option>
                ))}
              </Select>
            )}

            {subestadoLlamadaId === 4 && (
              <Alert
                message="Contacto Errónico"
                description="Aunque se logró comunicación, no era la persona correcta. El estado cambiará automáticamente a 'No Continúa'."
                type="info"
                showIcon
                style={{ marginTop: 10 }}
              />
            )}
          </div>
        )}
      </Card>
    </>
  );
};

export default CallResultStep;
